/**
 * Whether a repeatable row field should be shown (e.g. cônjuge only when estado civil is casado).
 * @param {object} field - schema field, optional `showWhen: { field, value }`
 * @param {object} item - one row of formData[groupKey]
 */
export function isRepeatableFieldVisible(field, item) {
  if (!field?.showWhen) return true;
  const { field: key, value } = field.showWhen;
  return item[key] === value;
}
